import { combineReducers } from 'redux';

import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';


import accountReducer from './accountReducer';
import staticDataReducer from './staticDataReducer';

const KEY_PREFIX = 'seinetcore-issuer-';

const reducers = combineReducers({
    account: persistReducer(
        {
            key: 'account',
            storage,
            keyPrefix: KEY_PREFIX
        },
        accountReducer
    ),
    staticData: persistReducer(
        {
            key: 'staticdata',
            storage,
            keyPrefix: KEY_PREFIX
        },
        staticDataReducer
    )  
});

export default reducers;